import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login } from "../login/loginSlice";
import { changeUsername } from "../home/userSlice";

export const createBank = createAsyncThunk(
    'signup/createBank',
    async (newBankInfo) => {
        const requestBody = JSON.stringify(newBankInfo);
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/admin/bank/create`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const createAdminUser = createAsyncThunk(
    'signup/createAdminUser',
    async (newAdminInfo) => {
        const requestBody = JSON.stringify(newAdminInfo);
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/signup`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: requestBody
            }
        )
        .then(response => response.json())
        return response;
    }
)

export const signup = createAsyncThunk(
    'signup/signup',
    async ({newBankInfo, newAdminInfo}, {dispatch}) => {
        const bankResult = await dispatch(createBank(newBankInfo));

        if (createBank.fulfilled.match(bankResult)) {
            const bank = bankResult.payload;
            newAdminInfo.bankId = bank.bankId;
            const userResult = await dispatch(createAdminUser(newAdminInfo));

            if (createAdminUser.fulfilled.match(userResult)) {
                dispatch(changeUsername(newAdminInfo.username));
                dispatch(login({username: newAdminInfo.username, password: newAdminInfo.password}));
            }
        } else {
            throw new Error('Failed to create bank.');
        }
    }
)

export const signupSlice = createSlice({
    name: 'signup',
    initialState: {
        adminUserId: '',
        adminName: '',
        adminPassword: '',
        bankName: '',
        signingUp: false,
        creatingBank: false,
        failedToCreateBank: false,
        bankSettings: {},
        creatingAdminUser: false,
        failedToCreateAdminUser: false,
        adminUser: {}
    },
    reducers: {
        changeSignupAdminUserId: (state, action) => {
            return {
                ...state,
                adminUserId: action.payload
            }
        },
        changeSignupAdminName: (state, action) => {
            return {
                ...state,
                adminName: action.payload
            }
        },
        changeSignupAdminPassword: (state, action) => {
            return {
                ...state,
                adminPassword: action.payload
            }
        },
        changeSignupBankName: (state, action) => {
            return {
                ...state,
                bankName: action.payload
            }
        }
    },
    extraReducers: {
        [createBank.pending]: (state) => {
            return {
                ...state,
                creatingBank: true,
                failedToCreateBank: false
            }
        },
        [createBank.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingBank: false,
                failedToCreateBank: false,
                bankSettings: action.payload
            }
        },
        [createBank.rejected]: (state) => {
            return {
                ...state,
                creatingBank: false,
                failedToCreateBank: true
            }
        },
        [createAdminUser.pending]: (state) => {
            return {
                ...state,
                creatingAdminUser: true,
                failedToCreateAdminUser: false
            }
        },
        [createAdminUser.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingAdminUser: false,
                failedToCreateAdminUser: false,
                adminUser: action.payload
            }
        },
        [createAdminUser.rejected]: (state) => {
            return {
                ...state,
                creatingAdminUser: false,
                failedToCreateAdminUser: true
            }
        }
    }
})

export const selectSignupAdminUserId = (state) => state.signup.adminUserId;
export const selectSignupAdminName = (state) => state.signup.adminName;
export const selectSignupAdminPassword = (state) => state.signup.adminPassword;
export const selectSignupBankName = (state) => state.signup.bankName;
export const isSigningUp = (state) => state.signup.signingUp;

export const { changeSignupAdminUserId, changeSignupAdminName, changeSignupAdminPassword, changeSignupBankName } = signupSlice.actions;

export default signupSlice.reducer;